module.exports = __webpack_public_path__ + "images/VivaEngageLogo-f2706ea734a3ce2884ed0360bf9a2d13.svg";